import * as Sentry from "@sentry/react";

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from "react-router";
import App from './App.jsx'

if (import.meta.env.MODE != 'development') {
  Sentry.init({
    dsn: "https://7826ef18a9bd28d24b06a0ef63528785@o4509038606024704.ingest.us.sentry.io/4509038607400960",
    integrations: [
      Sentry.browserTracingIntegration()
    ],
    tracesSampleRate: 0.2,
    tracePropagationTargets: [/^https:\/\/townsville\.today\/api/]
  });
}

createRoot(document.getElementById('root'), {
  onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
    console.warn('Uncaught error', error, errorInfo.componentStack);
  }),
  onCaughtError: Sentry.reactErrorHandler(),
  onRecoverableError: Sentry.reactErrorHandler(),
}).render(
  <StrictMode>
    <BrowserRouter>
      <App/>
    </BrowserRouter>
  </StrictMode>,
)
